import React from "react";

import Heading from "@common/components/Heading/Heading";
import { formatDayDuration } from "@common/models/helpers/time/dayDuration";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import { format } from "date-fns";

interface CurrentDurationCardProps extends ReleaseMetricCardBaseProps {
  days: number;
  startDate: string;
  endDate: string;
}

const CurrentDurationCard = ({
  style,
  days,
  startDate,
  endDate,
  score,
  highlight,
  error,
  onMoreClick,
}: CurrentDurationCardProps) => {
  const startDateStr = startDate ? format(new Date(startDate), "d MMM yyyy") : "-";
  const endDateStr = endDate ? format(new Date(endDate), "d MMM yyyy") : "-";

  return (
    <ReleaseMetricCard
      style={style}
      title={"Current duration"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      <Flex
        $column
        $justifyContent="center"
        style={{ height: "100%" }}
      >
        <Heading
          heading2
          style={{ marginRight: "1.8rem" }}
          marginBottom={0}
        >
          {formatDayDuration(days)}
        </Heading>
        <Heading
          heading3
          style={{ color: vars.colors.grey60, marginTop: "1.4rem" }}
          marginBottom={0}
        >{`🗓️ ${startDateStr} →`}</Heading>
        <Heading
          heading3
          style={{ color: vars.colors.grey60 }}
          marginBottom={0}
        >{`🗓 ${endDateStr}`}</Heading>
      </Flex>
    </ReleaseMetricCard>
  );
};

export { CurrentDurationCard };
